import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Sparkles, Loader2 } from "lucide-react";

export const MemberBrief = ({ lang, stateKey }) => {
  const tr = lang === "tr";
  const [x, setX] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/pilot/members/me/brief", { lang }); setX(data); } catch (er) { setX({ error: apiErr(er.response?.data?.detail) }); } finally { setBusy(false); }
  };
  useEffect(() => { setX(null); }, [lang, stateKey]);
  return (
    <div className="qs-grad-border p-4" data-testid="member-brief">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-[10px] uppercase tracking-widest text-[#F59E0B] inline-flex items-center gap-1"><Sparkles className="h-3 w-3" /> {tr ? "Sezonum bir bakışta" : "My season at a glance"} · Claude Sonnet 5.5</div>
        <button data-testid="member-brief-btn" onClick={run} disabled={busy} className="border border-[#F59E0B]/60 text-[#F59E0B] px-3 py-1 text-xs inline-flex items-center gap-1 hover:bg-[#F59E0B]/10 disabled:opacity-50">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Sparkles className="h-3 w-3" />} {x?.text ? (tr ? "Yenile" : "Refresh") : (tr ? "Özetimi yaz" : "Write my brief")}</button>
      </div>
      {x?.text && <p className="text-sm text-slate-300 leading-relaxed mt-2 whitespace-pre-line" data-testid="member-brief-text">{x.text}</p>}
      {x?.text && <div className="text-[10px] font-mono text-slate-600 mt-1">{x.at.slice(0, 16).replace("T", " ")} · anchor {x.anchor.slice(0, 22)}…</div>}
      {x?.error && <div className="text-xs text-[#EF4444] mt-2" data-testid="member-brief-error">{x.error}</div>}
      {!x && <p className="text-xs text-slate-500 mt-2">{tr ? "Bir sonraki kutunuz, taksit durumunuz, imece saatleriniz ve aldığınız kutuların kalite notları — kişisel, kısa bir özet." : "Your next box, instalment status, imece hours and the quality grades of boxes you received — a short personal brief."}</p>}
    </div>
  );
};
